import { useState } from "react";
import { Loader2, CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";

export const inputCls =
  "w-full rounded-xl border border-neutral-200 bg-white px-4 py-3.5 text-sm text-das-ink outline-none transition placeholder:text-neutral-400 focus:border-das-violet focus:ring-4 focus:ring-das-violet/15";

export const Field = ({ label, htmlFor, children }) => (
  <div className="space-y-2">
    <label htmlFor={htmlFor} className="block text-xs font-bold uppercase tracking-[0.16em] text-neutral-500">
      {label}
    </label>
    {children}
  </div>
);

export const SubmitButton = ({ loading, children, testid }) => (
  <button
    type="submit"
    disabled={loading}
    data-testid={testid}
    className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-das-violet px-8 py-4 font-display text-base font-semibold text-white transition-all duration-300 hover:bg-das-deep hover:shadow-lift disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto"
  >
    {loading ? (
      <>
        <Loader2 className="h-5 w-5 animate-spin" />
        Sending…
      </>
    ) : (
      children
    )}
  </button>
);

export const FormSuccess = ({ title, message, onReset, testid }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.96, y: 16 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    data-testid={testid}
    className="rounded-3xl border border-das-violet/25 bg-das-violet/5 p-10 text-center"
  >
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 0.15, type: "spring", stiffness: 260, damping: 16 }}
      className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-das-violet"
    >
      <CheckCircle2 className="h-8 w-8 text-white" />
    </motion.div>
    <h3 className="mt-6 font-display text-2xl font-semibold tracking-tight text-das-ink">{title}</h3>
    <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-neutral-600">{message}</p>
    {onReset && (
      <button
        onClick={onReset}
        data-testid="form-reset-button"
        className="mt-6 text-sm font-bold text-das-deep underline-offset-4 hover:underline"
      >
        Send another message
      </button>
    )}
  </motion.div>
);
